import {styled} from '@mui/system'

// NOTE: dimensions are fixed px values (not theme.spacing(n)) on purpose.
// This component is shared by legacy pages and new-style pages, whose themes
// use different spacing base units (legacy: 2, new: 8). Using theme.spacing(n)
// made the button balloon to ~4x its intended size when rendered inside
// ThemeProviderNew (e.g. the "Lista pazienti" filter on Incontri virtuali).
export const FilterButtonStyled = styled('div')(({theme}) => ({
  '.filter-button': {
    color: 'white',
    borderRadius: 50,
    width: 130,
    height: 44,
    textTransform: 'none',
    display: 'flex',
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    },

    '.filter-text': {
      padding: '10px 30px 10px 10px'
    },

    '& .MuiButton-startIcon': {
      borderRadius: 50,
      backgroundColor: 'rgba(255,255,255,.2)',
      padding: 6
    }
  },

  '.close-button': {
    color: theme.palette.primary.main,
    backgroundColor: 'white',
    borderRadius: 50,
    width: 130,
    height: 44,
    textTransform: 'none',
    display: 'flex',
    '&:hover': {
      backgroundColor: 'white'
    },

    '.close-text': {
      paddingRight: 16
    },

    '& .MuiButton-startIcon': {
      borderRadius: 50,

      backgroundColor: 'white',
      padding: 6
    }
  }
}))
